import React from "react";
import GuideHeader from "../Guide/GuideHeader";
import "./GuideSubjectLines.css";

const GuideSubjectLines = () => {
  const tips = [
    {
      number: 1,
      title: "Keep it short",
      text: "You want your readers to quickly understand what your email’s all about. Keep it under 30 characters – and if you can convey your point in only three or four words, even better.",
    },
    {
      number: 2,
      title: "Don’t be aggressive",
      text: "The fastest way to get caught by a spam filter is to put an aggressive sales pitch in your subject line. Avoid using all caps or more than one exclamation point. Don’t make it sound like a sales pitch; focus on the value to your subscriber. It should come across as a friendly offer, not a demand.",
    },
    {
      number: 3,
      title: "Make it personalised",
      text: "As the saying goes, the sweetest sound to anyone’s ears is the sound of their own name. Use a merge tag to include the reader’s name in the subject line, delighting them and attracting their attention.",
    },
    {
      number: 4,
      title: "Ask a question",
      text: "Questions help to build intrigue and can increase your open rate. If your reader thinks the answer to the question is in your email, they’re more likely to open it.",
    },
    {
      number: 5,
      title: "Convey urgency or curiosity",
      text: "Using time-sensitive language such as 'Ends today' or 'Limited offer' can motivate readers to open right away. Alternatively, spark curiosity with something intriguing but relevant to your audience.",
    },
    {
      number: 6,
      title: "Stand out from the rest",
      text: "It’s easy to forget how many emails your subscribers get from other companies. Your email might be interesting to you, but will it stand out? Think creatively about what makes your business or product special, and find a way to put this across in a way that’s unique to you.",
    },
    {
      number: 7,
      title: "Test across different devices",
      text: "Remember that your subject line will probably get cut off at different points on different devices. Send a test to yourself and take a look before you hit send – make sure it doesn’t get cut in a way that changes the email’s meaning or feels incomplete.",
    },
  ];

  return (
    <div className="guide-page">
      {/* ✅ Reusable Header */}
      <GuideHeader headingLevel="div" />

      {/* 📧 Content Section */}
      <section className="subject-content">
        <h1>How to write great email subject lines</h1>
        <p className="intro-text">
          Your subject line is the first thing your audience will read – and most likely, it’ll be
          sitting alongside a lot of other unread emails. Here are a few tips to make sure your
          subject lines will click to open, not delete.
        </p>

        <div className="subject-tips">
          {tips.map((tip) => (
            <div key={tip.number} className="tip-box">
              <div className="tip-number">{tip.number}</div>
              <div className="tip-content">
                <h3>{tip.title}</h3>
                <p>{tip.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="next-step">
          <p>With your subject line written, we can move on.</p>
          <p className="next-link">
            Read how to <a href="/guide">write an effective email →</a>
          </p>
        </div>
      </section>

      {/* 🌊 CTA Section */}
      <section className="guide-start">
        <h2>Start for free today</h2>
        <p>
          Sign up and send your first campaign in minutes. No credit card required.
        </p>
      </section>
    </div>
  );
};

export default GuideSubjectLines;
